import type { ReactNode } from 'react';
import { useInView } from '../../hooks/useInView';

interface RevealOnScrollProps {
  children: ReactNode;
  className?: string;
  delayMs?: number;
}

export function RevealOnScroll({ children, className = '', delayMs = 0 }: RevealOnScrollProps) {
  const { ref, inView } = useInView();

  return (
    <div
      ref={ref}
      className={`reveal-on-scroll ${inView ? 'is-visible' : ''} ${className}`}
      style={delayMs > 0 ? { transitionDelay: `${delayMs}ms` } : undefined}
    >
      {children}
    </div>
  );
}
